import(/* webpackMode: "eager" */ "C:\\website\\src\\app\\technology-safety\\page.tsx");
